import { de } from "./de.ts";
import { en } from "./en.ts";
import { isLocale, type Dictionary, type Locale } from "./dictionary.ts";

export const dictionaries: Record<Locale, Dictionary> = { de, en };

export const storageKey = "cms-analysis.locale";

export const fallbackLocale: Locale = "de";

/**
 * Picks the locale to start with: a stored choice wins, otherwise the first
 * browser language we speak, otherwise the fallback.
 */
export const preferredLocale = (stored: string | null, browserLanguages: readonly string[]): Locale => {
  if (stored !== null && isLocale(stored)) return stored;

  const spoken = browserLanguages
    .map((language) => language.slice(0, 2).toLowerCase())
    .find(isLocale);

  return spoken ?? fallbackLocale;
};
